if (!customElements.get('sc-campaign-carousel')) {
  customElements.define('sc-campaign-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('.sc-campaign__slide'));
      if (this.slides.length < 2) return;
      this.current = 0;
      this.busy = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.controls = this.querySelector('.sc-campaign__controls');
      this.status = this.querySelector('[data-status]');
      this.controls.hidden = false;
      this.querySelector('[data-next]').addEventListener('click', () => this.manual(1), options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.manual(-1), options);
      this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', e => {
        if (e.matches) { this.paused = true; this.updatePause(); this.schedule(); }
      }, options);
      const deck = this.querySelector('.sc-campaign__deck');
      deck.addEventListener('pointerdown', e => {
        if (e.pointerType === 'mouse') return;
        this.pointer = { x: e.clientX, y: e.clientY };
      }, options);
      deck.addEventListener('pointerup', e => {
        if (!this.pointer) return;
        const dx = e.clientX - this.pointer.x;
        const dy = e.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.suppressClickUntil = Date.now() + 500;
          this.manual(dx < 0 ? 1 : -1);
        }
      }, options);
      deck.addEventListener('pointercancel', () => { this.pointer = null; }, options);
      deck.addEventListener('click', e => {
        if (Date.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); e.stopPropagation(); }
      }, { ...options, capture: true });
      this.updatePause();
      this.schedule();
    }
    updatePause() {
      this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }
    schedule(delay = Number(this.dataset.interval) || 6000) {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || this.hovering || this.focused || document.hidden || this.busy) return;
      this.timer = setTimeout(() => this.turn(1), delay);
    }
    manual(direction) {
      this.turn(direction);
    }
    async turn(direction) {
      if (this.busy) return;
      clearTimeout(this.timer);
      const startedAt = performance.now();
      this.busy = true;
      const index = (this.current + direction + this.slides.length) % this.slides.length;
      const outgoing = this.slides[this.current];
      const incoming = this.slides[index];
      incoming.hidden = false;
      const timing = { duration: this.motion.matches ? 0 : 900, easing: 'cubic-bezier(.45,.05,.25,1)', fill: 'both' };
      const offset = direction > 0 ? -100 : 100;
      this.animations = [
        outgoing.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${offset}%)` }], timing),
        incoming.animate([{ transform: `translateX(${-offset}%)` }, { transform: 'translateX(0)' }], timing)
      ];
      await Promise.allSettled(this.animations.map(animation => animation.finished));
      if (!this.isConnected) return;
      if (outgoing.contains(document.activeElement)) this.querySelector('[data-next]').focus({ preventScroll: true });
      outgoing.hidden = true;
      outgoing.inert = true;
      outgoing.setAttribute('aria-hidden', 'true');
      incoming.inert = false;
      incoming.removeAttribute('aria-hidden');
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      this.current = index;
      this.querySelector('[data-next-image]').src = this.slides[(index + 1) % this.slides.length].querySelector('img').src + '&width=800';
      this.querySelector('[data-back-image]').src = incoming.querySelector('img').src + '&width=800';
      this.status.textContent = `${incoming.dataset.title} · ${index + 1} / ${this.slides.length}`;
      this.busy = false;
      this.schedule(Math.max(0, (Number(this.dataset.interval) || 6000) - (performance.now() - startedAt)));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.ready = false;
    }
  });
}
